export enum Languages {
    ENGLISH = 'en_CA',
    FRENCH = 'fr_CA',
}
